import { Fragment, useState } from "react"
import { Link } from "react-router-dom"
import { Grid, List, ListItemButton, ListItemIcon, ListItemText } from "@mui/material"
import { navItems } from "../utils/adminMenu";

const Sidebar = ({location,subItem}) => {
    
    const [menuItems,] = useState(navItems);
    const [applicationMenuOpen, setApplicationMenuOpen] = useState(true);

    const handleMenuOpen = ()=>{
        setApplicationMenuOpen(!applicationMenuOpen);
    }

    return (
    <Grid sx={{backgroundColor:"#0F5385",height:"100%",color:"white"}}>
        <List>
            {
            menuItems.map((item,i)=>(
            <Fragment key={i}>
                <Link to={item.href} style={{textDecoration:"none"}}>
                    <ListItemButton sx={{color:"white", backgroundColor:location === item.locationRef ? "#1A3B6B" : "#0F5385"}} onClick={item.pages?handleMenuOpen:null}>
                        <ListItemIcon>
                        {item.icon}
                        </ListItemIcon>
                        <ListItemText primary={item.title} slotProps={{primary:{variant:"subtitle2"}}}/>
                        {item.pages && applicationMenuOpen ? item.openIcon : item.closeIcon}
                    </ListItemButton>          
                </Link>
                {
                    item.pages && applicationMenuOpen && item.pages.map((subpages,j)=>(
                    <Link key={j} to={subpages.href} style={{textDecoration:"none"}}>
                        <ListItemButton sx={{marginLeft:"20px",color:"white",backgroundColor:(subItem === subpages.locationRef) ? "#1A3B6B" : "#0F5385"}}>
                        <ListItemText primary={subpages.title} slotProps={{primary:{variant:"subtitle2"}}}/>
                        </ListItemButton>
                    </Link>
                    ))
                }
            </Fragment>
            ))
            }
        </List>
    </Grid>
    )
}

export default Sidebar